<template>
  <div @click="$emit('widgetAdd');">
    <v-col class="d-flex flex-column align-center">
        <v-icon color="info" icon="mdi-cog"></v-icon>
      </v-col>

      <v-col style="word-break: break-all" class="d-flex flex-column align-center">
        <span>Зайти под именем</span>
      </v-col>
  </div>
</template>

<script>
export default {
  emits: ["widgetAdd"], //обязательный для всех виджетов
  props: {
    //обязательный для всех виджетов.клик по иконке. нужно открыть доп. настройки
    //или заэмитить widgetAdd
    showWidgetSettings: {
      required: true,
    },
  },
  name: "service",
  data() {
    return {
    };
  },
  watch: {
    
  },
  created() {
    
  },
  methods: {
  }
};
</script>
